module.exports = "<ion-modal-view ng-touchstart=\"$event.preventDefault()\">\r\n\t<ion-header-bar class=\"bar-positive modal-header-bar\" align-title=\"center\">\r\n\t\t<button class=\"button button-icon iconfont icon-iconclose\"\r\n\t\t\t\tng-click=\"closeSelectFolderModal()\">\r\n\t\t</button>\r\n\t\t<h1 class=\"title\"> {{'MAIL.FOLDER.TITLE' | translate}}</h1>\r\n\t</ion-header-bar>\r\n\r\n\t<ion-content class=\"has-header\" overflow-scroll=\"false\">\r\n\t\t<ng-include src=\"'views/mail/folders.html'\"></ng-include>\r\n\t</ion-content>\r\n</ion-modal-view>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/mail/folders-frame.html
// module id = ut9Z
// module chunks = 1